import { api } from '@/core/api/';

const billingHistoryApi = 'api/providerthrpybilling';

export const getAdjustmentsReasons = async () => {
  let { data } = await api
    .get(`${billingHistoryApi}/adjustmentsReasons`)
    .catch(() => {
      return [];
    });
  return data;
};

export const getAdjustments = (params) =>
  api.get(`${billingHistoryApi}/adjustments`, { params });
